module.exports = __webpack_public_path__ + "img/1-14.8356cd53.png";